import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Header, Table } from 'semantic-ui-react';
import moment from 'moment';

class Driver extends Component {
    constructor(props){
        super(props);
        this.state = { hidden: true};
        this.onClick = this.onClick.bind(this);
    }
    onClick(e){
        e.preventDefault();
        this.setState({
            hidden: !this.state.hidden
        });
    }
    render() {
        const {hidden} = this.state;
        const {driver} = this.props;

        var stars = driver.dln.length > 4 ? "*".repeat(driver.dln.length-4) : "";
        var last4 = driver.dln.length > 4 ? driver.dln.substring(driver.dln.length-4) : "";
        return (
            <div id={`driver-${driver.driverNum}`}>
                <div className="field">
                    <Header id={`driverName-${driver.driverNum}`} as="h2" className="driver">{driver.displayName}</Header> (<a id={`detailsBtn-${driver.driverNum}`} href="/#" onClick={this.onClick}>details</a>)
                </div>
                <div>
                    {driver.deleteFutureEffectiveDate ? (
                        <Header id={`driverEffectiveDate-${driver.driverNum}`} as="h2">
                            <b>  This driver is scheduled to delete on: {moment(driver.deleteFutureEffectiveDate).format('L')} </b>
                        </Header>
                    ) : null}
                </div>
                <br />
                {!hidden ? <div className="coverages">
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>DOB</Table.HeaderCell>
                                    <Table.HeaderCell>DLN</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell id={`driverBirthYear-${driver.driverNum}`}>{`**/**/${driver.birthYear}`}</Table.Cell>
                                    <Table.Cell id={`driverLast4-${driver.driverNum}`}>{stars + last4}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div> : null}
            </div>
        );
    }
}

Driver.propTypes = {
    driver: PropTypes.object.isRequired,
};

export default Driver;